<div class="hpanel gs-widget-cardmargin-bottom-5" *ngIf="viewType=='MIN'">
  <div class="panel-heading hbuilt wig-c">
    {{ headerTitle }}
  </div>
  <div class="panel-body gs-widget-body">
    <div class="row">
      <div class="col-lg-12">
        <!-- No data message -->
        <div class="gs-empty" *ngIf="peopelData.length === 0">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No people yet</div>
          <div class="gs-empty-sub">Connect with people to grow your network.</div>
        </div>
        <!-- People list -->
        <ul class="profile-list" *ngIf="peopelData.length > 0">
          <ng-container *ngFor="let item of peopelData | slice:0:5; let i=index">
            <app-common-profile-info [userIdInput]="item.userId" [data]="item" [type]="'MOSTACTIVE'"
              (click)="routes(item.userId)">
              <ng-container headline1 class="ellipse">{{item.firstName}} {{item.lastName}}</ng-container>
              <ng-container headline2 class="ellipse">{{item.organisation}}</ng-container>
            </app-common-profile-info>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="margin-bottom-5" *ngIf="viewType=='MAX'" infiniteScroll [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()">
  <div class="panel-body gs-widget-body cardw">
    <div class="row">
      <div class="col-3">
        <div class="col-md-3 padding-left-0 padding-right-5" *ngFor="let item of peopelData">
          <app-user-card [userDataInput]="item" [button]="'PRIMARY'" [standard]="true"></app-user-card>
        </div>
      </div>
    </div>
  </div>
</div>
